module.exports = __webpack_public_path__ + "img/DSC_3821.044de150.png";